


































































































import { Component, Vue } from "vue-property-decorator";
import AppFooter from "./components/app-footer.vue";
import { MetaInfo } from "vue-meta";
import { Action, Getter } from "vuex-class";
import * as _ from "lodash";

@Component({
  components: {
    AppFooter,
  },
  metaInfo(): MetaInfo {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: "Craigmyle Trucks",
      // all titles will be injected into this template
      titleTemplate: "%s - Craigmyle Trucks",
      htmlAttrs: {
        lang: "en",
        //amp: true
      },
    };
  },
})
export default class App extends Vue {
  @Getter user;
  @Getter loggedIn;
  @Getter admin;
  @Getter messages;
  @Getter uploads;

  @Action logout;

  async created() {
    await this.$store.dispatch("startup");
  }

  private metaInfo = {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Craigmyle Trucks",
    // all titles will be injected into this template
    titleTemplate: "%s - Craigmyle Trucks",
  };

  private adminLinks = [
    { name: "Vin Tool", to: "/admin/vin" },
    { name: "Report", to: "/admin/report" },
    { name: "Upload Log", to: "/admin/uploads" },
    { name: "Hacks", to: "/admin/hacks" },
  ];

  private settingsLinks = [
    { name: "Contacts", to: "/admin/contacts" },
    { name: "Users", to: "/admin/users" },
    { name: "Options", to: "/admin/equipment-options" },
    { name: "Tags", to: "/admin/equipment-tags" },
    { name: "Categories", to: "/admin/equipment-categories" },
    { name: "Statuses", to: "/admin/equipment-statuses" },
    { name: "Banners", to: "/admin/equipment-banners" },
    { name: "Expenses", to: "/admin/equipment-expenses" },
    { name: "Received Checklist", to: "/admin/equipment-received-checklist" },
    { name: "Sales Ready Checklist", to: "/admin/equipment-sales-ready-checklist" },
  ];

  routeTo(path: string) {
    this.$router.push(path);
  }

  get unreadMessages() {
    return _.filter(this.messages, (x) => !x.read).length + "";
  }

  get uploadErrors() {
    return _.filter(this.uploads, (x) => x.error).length + "";
  }
}
